import React, { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { ProductCategories } from './ProductCategories';
import { AddProduct } from './AddProduct';
import { EditProduct } from './EditProduct';
import { AddProductCategory } from './AddProductCategory';
import { EditProductCategory } from './EditProductCategory';


export const ProductRouter: FC = (props) => {

  const { path } = useRouteMatch();

  return (<Switch>
    <Route exact path={path}>
      <ProductCategories/>
    </Route>
    <Route path={`${path}/category/new`}>
      <AddProductCategory/>
    </Route>
    <Route path={`${path}/category/:id`}>
      <EditProductCategory/>
    </Route>
    <Route path={`${path}/new`}>
      <AddProduct/>
    </Route>
    <Route path={`${path}/:id`}>
      <EditProduct/>
    </Route>
  </Switch>);
};
